/* globals data, serverParams */
import Table from 'bam-node-savant-table/table'
import {
    allAttemptsHeaders,
    allAttemptsSecondaryHeaders,
    groupedHeaders,
    groupedSecondaryHeaders,
    headers,
    secondaryHeaders,
} from './headers'

const { entity_code, is_team_type, splitYears, team, target_base } =
    serverParams
const isLeague = entity_code === 'League'

const tableDivId = 'basestealing_running_game_table'

let currentData = data.slice()

const nameMap = {}

function loadTable(data, expanded = false) {
    const width = document.getElementById(tableDivId).offsetWidth
    let repeatHeader = false
    if (width <= 768) {
        repeatHeader = 15
    }
    const defaultSort = document.getElementById('sort').value
    const defaultSortDirection = document.getElementById('sortDir').value

    const selectedHeaders = headers.expanded

    const selectedSecondaryHeaders = expanded
        ? secondaryHeaders.expanded
        : secondaryHeaders.normal

    // Toggle a class to show/hide columns
    if (expanded) {
        document
            .getElementById(tableDivId)
            .classList.add('table-savant-expanded')
    } else {
        document
            .getElementById(tableDivId)
            .classList.remove('table-savant-expanded')
    }

    // eslint-disable-next-line no-new
    new Table({
        id: tableDivId,
        repeatHeader,
        secondaryHeaders: selectedSecondaryHeaders,
        headers: selectedHeaders,
        highlightFalsy: false,
        data,
        uniqueId: 'runner_id', // this can't have dashes in it
        defaultSort,
        defaultSortDirection,
        sortClass: 'column-sort',
        showRank: true,
        sortCallback(column, _, { state }) {
            const url = populateUrl(column, state)
            window.history.replaceState('', '', url)
        },
        subDataId: 'row_id',
        drawerAvailable: (row) => !isLeague && row.runner_moved > 0,
    })
}

let expanded = document.getElementById('expanded').value === '1'

if (data && data.length) {
    loadTable(currentData, expanded)

    document.getElementById('btn-columns').addEventListener('click', () => {
        expanded = !expanded
        document.getElementById('btn-columns').innerText = expanded
            ? 'Show Fewer Columns'
            : 'Show More Columns'
        loadTable(currentData, expanded)

        document.getElementById('expanded').value = expanded ? '1' : '0'

        const url = populateUrl()
        window.history.replaceState('', '', url)
    })

    document.getElementById(tableDivId).addEventListener('click', async (e) => {
        const $a = e.target.closest('a')

        if ($a) {
            return
        }

        const $el = e.target.closest('tr.default-table-row')
        const $button = e.target.closest('.drawer-nav')

        if (!$el && !$button) {
            return
        }

        if ($button) {
            handleButtonClick($button)
            return
        }

        const id = `data_${$el.dataset.id}`
        const $innerDiv = document.getElementById(id)

        const $sub = $el.nextSibling

        const isOpen = $sub.dataset.open === 'true'

        const $videoIcon = $el.querySelector('[data-video-icon]')

        if (!$videoIcon) {
            return
        }

        // Close drawer
        if ($innerDiv && isOpen) {
            slideUp($innerDiv, 400)
            $sub.dataset.open = 'false'
            $videoIcon.style.backgroundColor = 'white'
            return
        }

        // Open drawer color
        $videoIcon.style.backgroundColor = '#797979'

        // Open Drawer
        if ($innerDiv && !isOpen) {
            slideDown($innerDiv, 400)
            $sub.dataset.open = 'true'
            return
        }

        const $td = $sub.querySelector('td')

        const params = new URLSearchParams(window.location.search)

        // Eww.
        const [entity_id, year, team_id] = $el.dataset.id.split('_')

        params.set(
            'season_start',
            splitYears ? year : params.get('season_start') || ''
        )
        params.set(
            'season_end',
            splitYears ? year : params.get('season_end') || ''
        )
        params.set(
            'team',
            team === 'split' ? team_id : params.get('team') || ''
        )

        const $wrapperDiv = document.createElement('div')

        $wrapperDiv.classList.add('table-drawer')
        // A dirty hack, but a pretty effective one.
        // When the parent TD overflows horizontally, this makes sure the drawer table at least looks decent.
        $wrapperDiv.style.maxWidth = '95vw'
        $wrapperDiv.textContent = 'Loading...'
        // NO DASHES ALLOWED!
        $wrapperDiv.id = id

        $sub.style.display = 'table-row'
        $sub.dataset.open = 'true'

        $td.appendChild($wrapperDiv)

        const url = `/leaderboard/services/basestealing-running-game/${entity_id}?${params.toString()}`

        const { data } = await fetch(url).then((res) => res.json())

        // TEMPORARY HOPEFULLY Quick namemap
        const fields = ['runner', 'catcher', 'pitcher']

        data.forEach((row) => {
            fields.forEach((field) => {
                const name = row[`${field}_name`]
                if (name) {
                    nameMap[row[`${field}_id`]] = name
                }
            })
        })

        data.forEach((row) => {
            fields.forEach((field) => {
                const name = row[`${field}_name`]
                const mapName = nameMap[row[`${field}_id`]]
                if (!name && mapName) {
                    // eslint-disable-next-line no-param-reassign
                    row[`${field}_name`] = mapName
                }
            })
        })
        // END TEMP FIX

        $wrapperDiv.style.display = 'none'
        $wrapperDiv.textContent = ''

        $wrapperDiv.innerHTML = `
    <div class="drawer-tabs">
        <button data-tab="all" class="tab-all drawer-nav active" >
            All Attempts
        </button>
        <button data-tab="pitcher_id" class="tab-pitcher drawer-nav" style="display: ${
            entity_code !== 'Pit' ? 'block' : 'none'
        }">
            Pitchers
        </button>
        <button data-tab="catcher_id" class="tab-catcher drawer-nav" style="display: ${
            entity_code !== 'Cat' ? 'block' : 'none'
        }">
            Catchers
        </button>
        <button data-tab="runner_id" class="tab-runner drawer-nav" style="display: ${
            entity_code !== 'Run' ? 'block' : 'none'
        }">
            Runners
        </button>
        <button data-tab="fielder_id" class="tab-runner drawer-nav" >
            Fielders
        </button>
    </div>
    `

        const entities = [
            {
                group_entity_id: 'catcher_id',
                name: 'catcher_name',
                title: 'Catcher',
            },
            {
                group_entity_id: 'pitcher_id',
                name: 'pitcher_name',
                title: 'Pitcher',
            },
            {
                group_entity_id: 'fielder_id',
                name: 'fielder_name',
                title: 'Fielder',
            },
            {
                group_entity_id: 'runner_id',
                name: 'runner_name',
                title: 'Runner',
            },
        ]

        entities
            .map(({ group_entity_id, name, title }) => ({
                group_entity_id,
                name,
                title,
                grouped: groupDataByEntity(data, group_entity_id, name),
            }))
            .forEach(({ group_entity_id, title, grouped }) => {
                if (
                    grouped.length &&
                    (entity_id !== 'catcher_id' || entity_code !== 'Cat')
                ) {
                    createGroupedTable(
                        $wrapperDiv,
                        id,
                        grouped,
                        title,
                        group_entity_id
                    )
                } else {
                    $wrapperDiv
                        .querySelector(`[data-tab="${group_entity_id}"]`)
                        .classList.add('hide')
                }
            })

        createAllAttemptsTable($wrapperDiv, id, data)

        slideDown($wrapperDiv, 400)
    })

    const $input = document.querySelector('.table-search')

    if ($input) {
        $input.addEventListener('input', (e) => {
            currentData = getFilteredData(e.target.value)
            loadTable(currentData, expanded)
        })
    }
}

function showWithTeam(value) {
    if (is_team_type) {
        return
    }

    const display = ['', 'split'].includes(value) ? 'none' : 'inline-flex'
    document.getElementById('with-team-only-wrapper').style.display = display
}
document.querySelectorAll('.form-control').forEach((el) => {
    el.addEventListener('change', (e) => {
        const id = el.getAttribute('id')
        const type = id.slice(3)
        const { selectedIndex } = e.target
        document.querySelector(`.label-change-${type}`).innerText =
            e.target.value === 'split'
                ? 'All - Split by Team'
                : e.target[selectedIndex].text

        if (type === 'Team') {
            showWithTeam(e.target.value)
        }
    })
})

showWithTeam(serverParams.team || '')

function populateUrl(sortColumn, sortDirection) {
    const parameters = {
        game_type: document.getElementById('ddlGameType').value,
        n: document.getElementById('ddlMinPitches').value,
        pitch_hand: document.getElementById('ddlPitchHand').value,
        runner_moved: document.getElementById('ddlRunnerMoved').value,
        target_base: document.getElementById('ddlTargetBase').value,
        prior_pk: document.getElementById('ddlPriorPk').value,
        season_end: document.getElementById('ddlSeasonEnd').value,
        season_start: document.getElementById('ddlSeasonStart').value,
        sortColumn: document.getElementById('sort').value,
        sortDirection: document.getElementById('sortDir').value,
        split: document.getElementById('ddlSplitYears').value,
        team: document.getElementById('ddlTeam').value,
        type: document.getElementById('ddlGroup').value,
        with_team_only: document.getElementById('with-team-only').checked
            ? 1
            : 0,
        expanded: expanded ? 1 : 0,
    }

    // Should we remove this?
    if (sortColumn) {
        parameters.sortColumn = sortColumn
        document.getElementById('sort').value = sortColumn
    }

    if (sortDirection) {
        parameters.sortDirection = sortDirection
        document.getElementById('sortDir').value = sortDirection
    }

    const urlParams = new URLSearchParams(parameters)

    return `${window.location.pathname}?${urlParams.toString()}`
}

document.getElementById('btn-update').addEventListener('click', () => {
    window.location = populateUrl()
})

// HT: https://codepen.io/ivanwebstudio/pen/OJVzPBL?editors=0110
/* eslint-disable no-param-reassign */
function slideUp(target, duration = 500) {
    target.style.transitionProperty = 'height, margin, padding'
    target.style.transitionDuration = `${duration}ms`
    target.style.boxSizing = 'border-box'
    target.style.height = `${target.offsetHeight}px`
    // eslint-disable-next-line no-unused-expressions, @typescript-eslint/no-unused-expressions
    target.offsetHeight
    target.style.overflow = 'hidden'
    target.style.height = 0
    target.style.paddingTop = 0
    target.style.paddingBottom = 0
    target.style.marginTop = 0
    target.style.marginBottom = 0
    window.setTimeout(() => {
        target.style.display = 'none'
        target.style.removeProperty('height')
        target.style.removeProperty('padding-top')
        target.style.removeProperty('padding-bottom')
        target.style.removeProperty('margin-top')
        target.style.removeProperty('margin-bottom')
        target.style.removeProperty('overflow')
        target.style.removeProperty('transition-duration')
        target.style.removeProperty('transition-property')
    }, duration)
}

function slideDown(target, duration = 500) {
    target.style.removeProperty('display')
    let { display } = window.getComputedStyle(target)

    if (display === 'none') display = 'block'

    target.style.display = display
    const height = target.offsetHeight
    target.style.overflow = 'hidden'
    target.style.height = 0
    target.style.paddingTop = 0
    target.style.paddingBottom = 0
    target.style.marginTop = 0
    target.style.marginBottom = 0
    // eslint-disable-next-line no-unused-expressions, @typescript-eslint/no-unused-expressions
    target.offsetHeight
    target.style.boxSizing = 'border-box'
    target.style.transitionProperty = 'height, margin, padding'
    target.style.transitionDuration = `${duration}ms`
    target.style.height = `${height}px`
    target.style.removeProperty('padding-top')
    target.style.removeProperty('padding-bottom')
    target.style.removeProperty('margin-top')
    target.style.removeProperty('margin-bottom')
    window.setTimeout(() => {
        target.style.removeProperty('height')
        target.style.removeProperty('overflow')
        target.style.removeProperty('transition-duration')
        target.style.removeProperty('transition-property')
    }, duration)
}
/* eslint-enable no-param-reassign */

function groupDataByEntity(
    runnerData,
    grouped_entity = 'runner_id',
    grouped_name = 'runner_name'
) {
    const groupedMap = runnerData.reduce((acc, curr) => {
        if (!acc[curr[grouped_entity]]) {
            acc[curr[grouped_entity]] = []
        }

        acc[curr[grouped_entity]].push(curr)

        return acc
    }, {})

    const grouped = Object.values(groupedMap)
        .sort((a, b) => {
            if (b.length !== a.length) {
                return b.length - a.length
            }

            const nameA = nameMap[a[0][grouped_entity]]
            const nameB = nameMap[b[0][grouped_entity]]

            if (!nameA) {
                return -1
            }

            return nameA.localeCompare(nameB)
        })
        // Remove Fielders/Others that don't have names
        .filter(
            (d) =>
                (target_base === '2B' ? d.length > 1 : d.length >= 1) &&
                d[0][grouped_name]
        )
        .map((groupData) => {
            // Sum SBA
            const sba = groupData.length
            // Average Est CS
            // const avgEstCS = groupData.reduce(
            //     (acc, curr) => curr.exp_cs / sba + acc,
            //     0
            // )

            const lead_values = groupData.filter((d) => d.r_primary_lead)
            const r_primary_lead = lead_values.length
                ? lead_values.reduce(
                      (acc, curr) => acc + Number(curr.r_primary_lead),
                      0
                  ) / lead_values.length
                : null

            const r_secondary_lead = lead_values.length
                ? lead_values.reduce(
                      (acc, curr) => acc + Number(curr.r_secondary_lead),
                      0
                  ) / lead_values.length
                : null

            // Sum Types
            const cs = groupData.filter((d) => d.is_runner_cs === 1).length
            const sb = groupData.filter((d) => d.is_runner_sb === 1).length
            const pk = groupData.filter((d) => d.is_runner_pk === 1).length
            const bk = groupData.filter((d) => d.is_runner_bk === 1).length
            const fb = groupData.filter((d) => d.is_runner_fb === 1).length

            // // CSAA
            // const csaa = groupData.reduce(
            //     (acc, curr) => curr.pitcher_cs_aa + acc,
            //     0
            // )

            const runnerStealingRuns = groupData.reduce(
                (acc, curr) => curr.runs_stolen_on_running_act + acc,
                0
            )

            const entity_name = groupData[0][grouped_name]

            return {
                entity_id: groupData[0][grouped_entity],
                entity_name,
                // est_cs: avgEstCS,
                sba,
                sb,
                pk,
                bk,
                fb,
                cs,
                runs_stolen_on_running_act: runnerStealingRuns,
                cs_pct: cs / sba,
                r_primary_lead,
                r_secondary_lead,
                r_sec_minus_prim_lead: lead_values.length
                    ? r_secondary_lead - r_primary_lead
                    : null,
            }
        })

    return grouped
}

function createAllAttemptsTable($wrapper, id, allData) {
    const data = allData

    const $tabWrapper = document.createElement('div')
    $tabWrapper.classList.add('all-tab-pane')
    $tabWrapper.classList.add('tab-pane')
    $tabWrapper.classList.add('active')

    const $h3All = document.createElement('h3')
    $h3All.innerText = 'All Stolen Base Attempts'
    $h3All.style.marginBottom = '10px'

    const $allTableDiv = document.createElement('div')
    $allTableDiv.id = `all_${id}`

    $tabWrapper.appendChild($h3All)
    $tabWrapper.appendChild($allTableDiv)

    $wrapper.appendChild($tabWrapper)

    // eslint-disable-next-line no-new
    new Table({
        id: $allTableDiv.id,
        data,
        sortClass: 'column-sort',
        secondaryHeaders: allAttemptsSecondaryHeaders,
        headers: allAttemptsHeaders,
        defaultSort: 'game_date',
        defaultSortDirection: 'asc',
    })
}
function createGroupedTable($wrapper, id, groupedData, title, slug) {
    // $wrapper > $tabWrapper > ($h3Grouped + $groupedSubTitleDiv + $groupedTableDiv)
    const $tabWrapper = document.createElement('div')
    $tabWrapper.classList.add(`${slug}-tab-pane`)
    $tabWrapper.classList.add('tab-pane')

    const $h3Grouped = document.createElement('h3')
    // capitalize first letter
    $h3Grouped.innerText = `${title} Summary`
    $h3Grouped.style.marginBottom = 0

    const $groupedSubTitleDiv = document.createElement('div')
    $groupedSubTitleDiv.innerText =
        slug !== 'throw_type' && target_base === '2B'
            ? 'Minimum 2 Attempts'
            : ''
    $groupedSubTitleDiv.style.marginBottom = '10px'
    $groupedSubTitleDiv.style.fontStyle = 'italic'

    const $groupedTableDiv = document.createElement('div')
    $groupedTableDiv.id = `${slug}_${id}`

    $tabWrapper.appendChild($h3Grouped)
    $tabWrapper.appendChild($groupedSubTitleDiv)
    $tabWrapper.appendChild($groupedTableDiv)

    $wrapper.appendChild($tabWrapper)

    // eslint-disable-next-line no-new
    new Table({
        id: $groupedTableDiv.id,
        data: groupedData,
        sortClass: 'column-sort',
        headers: groupedHeaders,
        secondaryHeaders: groupedSecondaryHeaders,
        defaultSort: 'sba',
        defaultSortDirection: 'desc',
    })
    return $tabWrapper
}

function handleButtonClick($button) {
    // all buttons
    $button
        .closest('.drawer-tabs')
        .querySelectorAll('.drawer-nav')
        .forEach(($el) => {
            $el.classList.remove('active')
        })

    // add active button
    $button.classList.add('active')

    // all tabs
    const $drawer = $button.closest('.table-drawer')

    $drawer.querySelectorAll('.tab-pane').forEach(($el) => {
        $el.classList.remove('active')
    })

    $drawer
        .querySelector(`.${$button.dataset.tab}-tab-pane`)
        .classList.add('active')
}

function getFilteredData(search) {
    const normalized_search = search
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()

    return data.filter((d) => {
        const name = d.entity_name
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()

        return name.includes(normalized_search)
    })
}

document.getElementById('btn-csv').addEventListener('click', () => {
    window.location.href = window.location.search
        ? `${window.location.href}&csv=true`
        : `${window.location.href}?csv=true`
})
